import { Injectable } from '@angular/core';

import { TmsWebBaseEditService } from '../../base';
import { ReplenishmentRequirement } from '../../../models/stock';

// Read-only: the screen only searches. It extends the edit service so <app-search-grid> can
// drive it; create and delete are switched off in the template.
@Injectable({
  providedIn: 'root',
})
export class ReplenishmentRequirementService extends TmsWebBaseEditService<
  ReplenishmentRequirement,
  ReplenishmentRequirement
> {
  constructor() {
    super('Replenishment', $localize`Replenishment`);
  }
}
